import { render, staticRenderFns } from "./LocalRunForm.vue?vue&type=template&id=55d2282f&"
import script from "./LocalRunForm.vue?vue&type=script&lang=js&"
export * from "./LocalRunForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports